<!-- 联盟商品清单列表 -- 联盟成员专属页面 -->
<template>
    <div class="business-content-main" v-loading="saveLoading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-files" class="search-btn btn-primary" v-if="permission.orderGoods"
                    @click="gotoOrderPage()">{{
                        permission.orderGoods
                    }}</el-button>
                <el-button size="small" class="search-btn btn-primary" v-if="permission.batchUpdateGoods"
                    @click="batchUpdate()">{{
                        permission.batchUpdateGoods
                    }}</el-button>
                <el-button size="small" type="warning" class="search-btn" v-if="permission.batchFetch" :disabled="tableDataLength == 0"
                    @click="batchFetch()">{{
                        permission.batchFetch + ' ( ' + tableDataLength + ' )'
                    }}</el-button>
                <div class="search-name color-red">检测到未关联商品 {{ unLinkCount }} 个</div>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">汽配编码</div>
                <el-input class="search-item" size="small" v-model="searchData.APCode" placeholder="请输入汽配编码"></el-input>
                <div class="search-name">汽配名称</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.GoodName"
                    placeholder="请输入汽配名称"></el-input>
                <div class="search-name">适用车型</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.AutoSerise"
                    placeholder="适用车型"></el-input>
                <div class="search-name">可购数</div>
                <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol" clearable
                    placeholder="> < =">
                    <el-option key=">=" label=">=" value=">="></el-option>
                    <el-option key=">" label=">" value=">"></el-option>
                    <el-option key="<=" label="<=" value="<="></el-option>
                    <el-option key="<" label="<" value="<"></el-option>
                    <el-option key="=" label="=" value="="></el-option>
                    <el-option key="!=" label="!=" value="!="></el-option>
                    <el-option key="between" label="区间" value="between"></el-option>
                </el-select>
                <el-input class="search-item" size="small" style="width: 90px" v-model.trim="searchData.Invent1"></el-input>
                <el-input class="search-item" size="small" style="width: 90px" v-model.trim="searchData.Invent2"
                    v-if="searchData.Symbol == 'between'"></el-input>
                <div class="search-name">品牌</div>
                <div class="search-item goods-categories">
                    <el-select v-model="searchData.BrandName" multiple collapse-tags filterable clearable size="small"
                        style="width: 100%" @visible-change="brandVisibleChange($event)">
                        <el-option :key="item.Text" v-for="item in brand" :label="item.Text" :value="item.Text"></el-option>
                    </el-select>
                </div>
                <div class="search-name">汽配分类</div>
                <div class="search-item goods-categories">
                    <el-select size="small" style="width: 100%" v-model="searchData.Cate" multiple collapse-tags filterable
                        clearable @visible-change="cateVisibleChange($event)">
                        <el-option v-for="optionItem in typeList1" :key="optionItem.Value" :label="optionItem.Text"
                            :value="optionItem.Value">
                            <div class="option-content">
                                <div>{{ optionItem.Text }}</div>
                            </div>
                        </el-option>
                    </el-select>
                </div>
                <div class="search-name">关联状态</div>
                <div class="search-item goods-categories">
                    <el-select size="small" style="width: 100%" v-model="searchData.ReleState">
                        <el-option key="-1" label="全部" value="-1"> </el-option>
                        <el-option key="0" label="无关联" value="0"> </el-option>
                        <el-option key="1" label="有关联" value="1"> </el-option>
                    </el-select>
                </div>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary"
                    @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary"
                    @click="resetSearch">重置</el-button>
            </div>
        </div>
        <template>
            <div class="table-ctn">
                <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%"
                    @selection-change="handleSelectionChange" @cell-dblclick="handleDBClick" @sort-change="sortChange">
                    <el-table-column type="selection" width="55" fixed="left"></el-table-column>
                    <el-table-column width="180px" label="汽配编码" prop="APCode" sortable="custom" fixed="left"
                        show-overflow-tooltip>
                        <template slot="header">
                            汽配编码
                        </template>
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.MainImg" icon="el-icon-picture" type="text"
                                @click="getGoodsImages(scope.row.GoodsId)"></el-button>
                            {{ scope.row.APCode }}</template>
                    </el-table-column>
                    <el-table-column min-width="180px" label="汽配名称" prop="GoodName" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="250px" label="适用车型" prop="AutoSerise"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="100px" label="汽配分类" prop="Cate" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="120px" label="汽配品牌" prop="Brand" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="120px" label="可购数量" prop="Count" sortable="custom"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="120px" label="价格" prop="Price" sortable="custom" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="80px" prop="Unit" label="单位"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100px" prop="IsRele" label="是否有关联">
                        <template slot-scope="scope">{{ scope.row.IsRele ? '有关联' : '无关联' }}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="120px" prop="MyAPCode" label="关联编码"><template
                            slot-scope="scope">
                            <div style="color: #409eff" @click="showAPMsgDialog(scope.row.MyGoodsId)" type="text">
                                {{ scope.row.MyAPCode }}
                            </div>
                        </template></el-table-column>
                    <el-table-column show-overflow-tooltip width="100px" label="我的留余">
                        <template v-slot:header>
                            <el-tooltip effect="dark" placement="bottom">
                                <div slot="content">留余=总库存数－总待出数＋总待入数</div>
                                <span>
                                    <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                                </span>
                            </el-tooltip>
                            我的留余
                        </template>
                        <template v-slot="{ row }">
                            <div class="div-padding-12">
                                <el-tooltip effect="dark"
                                    :content="'待入仓(' + row.POrderWaitInQuantity + '）  待出仓(' + row.OrderWaitOutQuantity + '）  库存(' + row.MyInventory + '）'"
                                    placement="top">
                                    <span :class="{
                                        'color-red': row.MyInventory + row.POrderWaitInQuantity - row.OrderWaitOutQuantity <= 0
                                    }">{{ row.MyInventory + row.POrderWaitInQuantity - row.OrderWaitOutQuantity
}}</span>
                                </el-tooltip>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="160px" label="更新时间" prop="UpdateTime" sortable="custom"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column fixed="right" label="操作" :autoWidth="true">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button type="text" size="mini" @click="fetchGoods(scope.row)"
                                    v-if="permission.fetchGoodsInfo && !scope.row.IsMine && !scope.row.IsRele"
                                    title="提取联盟的商品数据创建属于自己的库存商品">{{ permission.fetchGoodsInfo }}</el-button>
                                <el-button type="text" size="mini" @click="releGoods(scope.row)" title="关联已有的库存商品"
                                    v-if="permission.releGoodsInfo && !scope.row.IsMine && !scope.row.IsRele">{{
                                        permission.releGoodsInfo }}</el-button>
                                <el-button type="text" size="mini"
                                    v-if="permission.releGoodsInfo && scope.row.IsRele && !scope.row.IsMine"
                                    title="重新关联已有的库存商品" @click="reReleGoods(scope.row)"
                                    style="color: orange">重新关联</el-button>
                                <el-button type="text" size="mini" style="color: red"
                                    @click="showCorrectAPMsgDialog(scope.row.GoodsId)"
                                    v-if="permission.correction && !scope.row.IsMine">{{ permission.correction
                                    }}</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="searchData.page" :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit" layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"></el-pagination>
            </div>
        </template>
        <!--    查看库存    -->
        <el-dialog :close-on-click-modal="false" title="提取商品信息" :visible.sync="tranAPVisible" width="1000px">
            <div v-if="tranAPVisible">
                <TranGoods :EntpGoodsId="goodsId" :Type="4" @closeDialog="closeTranAPDialog"></TranGoods>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="关联商品信息" :visible.sync="searchAPVisible" width="1000px">
            <div v-if="searchAPVisible">
                <SearchGoods :EntpGoodsId="goodsId" :Type="4" @closeDialog="closeSearchAPDialog"></SearchGoods>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="供应商信息" :visible.sync="dialogFetchVisible" width="1000px">
            <div class="dialog-content" v-if="dialogFetchVisible">
                <EntityEdit :releEntpId="releEntpId" :type="1" @closeDialog="closeEntityDialog" :source="2"></EntityEdit>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="关联供应商信息'" :visible.sync="dialogReleVisible" width="1000px">
            <div v-if="dialogReleVisible">
                <ReleEntpEntity :releEntpId="releEntpId" :source="2" @closeDialog="closeReleDialog"></ReleEntpEntity>
            </div>
        </el-dialog>
        <RecorrectUnionAPMsg v-if="recorrectAPMsgVisible" :dialogFormVisible="recorrectAPMsgVisible" :UnionGoodsId="goodsId"
            :SType="0" @closeDialog="closeRecorrectAPMsgDialog"></RecorrectUnionAPMsg>
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="goodsId" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <el-progress v-if="searchApParams._visible" type="circle" :percentage="searchApParams._percentage"
            class="saveProgress" :class="{ hide: !saveLoading }"></el-progress>
        <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="srcList" :z-index="99999"/>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import TranGoods from '@/components/entpUnion/goodsManage/releGoods.vue';
import RecorrectUnionAPMsg from '@/components/entpUnion/goodsManage/recorrectUnionAPMsg.vue';
import SearchGoods from '@/components/entpUnion/goodsManage/searchGoods.vue';
import EntityEdit from '@/components/entpUnion/entityManage/entityEdit';
import ReleEntpEntity from '@/components/entpUnion/entityManage/releEntpEntity';
import APMsg from '@/components/common/APMsg';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import { PassThrough } from 'stream';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'goodListForMember',
    components: {
        breadcrumb,
        TranGoods,
        SearchGoods,
        elTableColumn,
        EntityEdit,
        ReleEntpEntity,
        RecorrectUnionAPMsg,
        APMsg,
        ElImageViewer
    },
    data() {
        return {
            goodsMsg: {},
            saveLoading: false,
            multipleSelection: [],
            brand: [],
            uGoods: {},
            goodsId: '',
            typeList1: [],
            tranAPVisible: false,
            searchAPVisible: false,
            isShowInvenSet: false,
            dialogFetchVisible: false,
            dialogReleVisible: false,
            recorrectAPMsgVisible: false,
            APMsgVisible: false,
            releEntpId: '',
            searchData: {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                AutoSerise: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                Cate: [],
                SortProp: '',
                SortType: '',
                ReleState: '-1',
                page: 1,
                limit: this.commonPageSize
            },
            levelList: [],
            goodsCategories: [],
            tableData: [],
            tableDataLength: 0,
            permission: {},
            searchApParams: {
                _visible: false,
                _percentage: 0,
                _limit: 200,
                // 总数量
                _totalCount: 0
            },
            srcList: [],
            showViewer: false,
            unLinkCount: 0
        };
    },
    mounted() {
        this.permission = this.$util.getUnionPermission('MemberGoodsList');
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getTableData();
    },
    activated() {
        if (this.$store.state.needRefresh) {
            this.$store.commit('updateNeedRefresh', false);
            this.getTableData();
        } else {
            this.$util.setEnterEvent(this, this.$route.fullPath);
        }
    },
    filters: {
        priceHandle(value, levelId) {
            let obj = value.find(item => item.LevelId === levelId);
            if (obj) return obj.Price;
            else return 0;
        }
    },
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        gotoOrderPage() {
            if (this.multipleSelection.length) {
                for (let index = 0; index < this.multipleSelection.length; index++) {
                    if (!this.multipleSelection[index].IsRele) {
                        this.$util.warningMsg('所要下单的商品中还有未关联的商品，请先关联再进行下单');
                        return;
                    }
                }
                this.getUnionReleResults().then(data => {
                    if (data.IsRele && data.EntpCusId) {
                        this.$util.setLocalStorage('BuyUnionAP', this.multipleSelection);
                        this.$router.push('/entpUnion/unionOrdersManage/tranUnionOrders?entpCusId=' + data.EntpCusId + '&entpCusName=' + data.EntpCusName + '&type=4');
                    } else this.$util.warningMsg('未进行实体关联或联盟本实体不能进行下单');
                });
            } else this.$util.warningMsg('请选择要下单的商品');
        },
        // 配件信息
        showAPMsgDialog(id) {
            this.goodsId = id;
            this.APMsgVisible = true;
        },
        closeAPMsgDialog() {
            this.APMsgVisible = false;
        },
        searchGoodsBrand() {
            if (this.brand.length > 0) return;
            this.loading = true;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brand = data;
                    this.loading = false;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        searchGoodsType() {
            if (this.typeList1.length > 0) return;
            this.loading = true;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList1 = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 重置表单
        resetSearch() {
            this.searchData = {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                AutoSerise: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                Cate: [],
                SortProp: '',
                SortType: '',
                ReleState: '-1',
                page: 1,
                limit: this.commonPageSize
            };
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        // 获取数据
        getTableData() {
            if (this.searchData.Symbol) {
                //''空值isNan 也是返会false 所以要加parseInt做强制转换
                if (this.searchData.Symbol == 'between') {
                    if (isNaN(parseInt(this.searchData.Invent1))) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                    if (isNaN(parseInt(this.searchData.Invent2))) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                } else {
                    if (isNaN(parseInt(this.searchData.Invent1))) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                }
            } else {
                this.searchData.Invent1 = 0;
                this.searchData.Invent2 = 0;
            }

            this.$util
                .axiosPost({
                    url: '/api/EntpUnionGoods/GetGoodsListForUnionMember',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data || !data.DataList) {
                        this.tableData = [];
                        this.tableDataLength = 0;
                        this.unLinkCount=0;
                    }
                    else {
                        for (let i = 0; i < data.DataList.length; i++) {
                            data.DataList[i].AutoSeries = [];
                        }
                        this.tableData = data.DataList;
                        this.tableDataLength = res.count;
                        this.unLinkCount = data.UnLinkCount;
                    }
                })
                .catch(() => { });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event.EntpTempGoodsId) {
                this.showAPMsgDialog(event.EntpTempGoodsId);
            }
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brand.length == 0) that.searchGoodsBrand();
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList1.length == 0) that.searchGoodsType();
            }
        },
        closeTranAPDialog(isEdit) {
            this.tranAPVisible = false;
            if (isEdit) this.getTableData();
        },
        fetchGoods(goods) {
            if (goods) {
                if (goods.IsHaveSameCode) {
                    this.$confirm('检测到您有相同的编码，是否继续提取，创建新的配件商品', '提示', {
                        confirmButtonText: '确定继续提取',
                        cancelButtonText: '去关联',
                        type: 'warning',
                        center: false
                    })
                        .then(() => {
                            this.tranAPVisible = true;
                            this.goodsId = goods.GoodsId;
                        })
                        .catch(() => {
                            this.searchAPVisible = true;
                            this.goodsId = goods.GoodsId;
                        });
                } else {
                    this.tranAPVisible = true;
                    this.goodsId = goods.GoodsId;
                }
            }
        },
        closeSearchAPDialog(isEdit) {
            this.searchAPVisible = false;
            if (isEdit) this.getTableData();
        },
        releGoods(goods) {
            if (goods) {
                this.searchAPVisible = true;
                this.goodsId = goods.GoodsId;
            }
        },
        reReleGoods(goods) {
            if (goods) {
                this.$confirm('您确定要重新进行商品关联吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '不了',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.searchAPVisible = true;
                        this.goodsId = goods.GoodsId;
                    })
                    .catch(() => { });
            }
        },
        batchFetch() {
            this.$confirm('您确定要提取现筛选结果的所有商品吗？（编码相同的商品将自动关联，如已经关联的将不会再进行关联）', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '不了',
                type: 'warning',
                center: false
            })
                .then(() => {
                    this.saveLoading = true;
                    this.searchApParams = {
                        ...this.searchData,
                        limit: this.searchApParams._limit,
                        _visible: true,
                        _percentage: 0,
                        _limit: this.searchApParams._limit,
                        // _totalCount: this.tableDataLength
                        _totalCount:0,
                        getCount:0,
                        fetchCount:0
                    };
                    this.loopSearch();
                })
                .catch(() => { });
        },
        // 开始循环
        async loopSearch() {
            let resp = await this.$util.axiosPost({
                url: '/api/EntpUnionGoods/BatchFetchAllSearchResult',
                data: this.searchApParams,
                hideLoading: true
            });
            if(this.searchApParams.page ==1&&this.searchApParams._totalCount==0)
                this.searchApParams._totalCount=resp.data.totalCount;
            
            this.searchApParams.getCount+=resp.data.getCount;
            this.searchApParams.fetchCount+=resp.data.fetchCount;
            // this.searchApParams._percentage = parseInt(((this.searchApParams.page * this.searchApParams.limit) / this.searchApParams._totalCount) * 100);
            // let _stop = this.searchApParams._totalCount - (this.searchApParams.page * this.searchApParams.limit) < this.searchApParams.limit;
            this.searchApParams._percentage = parseInt((this.searchApParams.getCount / this.searchApParams._totalCount) * 100);
            let _stop = this.searchApParams._totalCount ==this.searchApParams.getCount;            
            
            //这里重新取第一页的原因是:加上筛选条件比如’无关联‘状态，但是进行了分页保存导致了查询的总数与第一次查询的不一致了，导致当前页取不到数据，实际上还有未处理完的数据
            if(resp.data.getCount==0)
                this.searchApParams.page=1;
            else
                this.searchApParams.page += 1;
            if (_stop) {
                this.searchApParams._percentage = 100;
                this.searchApParams._visible = false;
                this.saveLoading = false;
                let msg = `提取数${this.searchApParams.fetchCount}，跳过商品数${this.searchApParams._totalCount-this.searchApParams.fetchCount}`;
                this.$alert(msg, '保存成功', { confirmButtonText: '确定' });
                this.getTableData();
            } else {
                this.loopSearch();
            }
        },
        batchUpdate() {
            var that = this;
            if (that.multipleSelection.length == 0) {
                this.$confirm('您确定要更新现筛选结果的所有商品吗？（更新的商品必须是已经有关联的商品）如果数据过多可能耗时稍长。', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '不了',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.saveLoading = true;
                        that.searchApParams = {
                            ...that.searchData,
                            limit: 100,
                            _visible: true,
                            _percentage: 0,
                            _limit: 100,
                            _totalCount: 0,
                            editCount: 0,
                            jumpCount: 0
                        };
                        that.loopUpdateGoods();
                    })
                    .catch(() => { });
            } else {
                let ids = [];
                for (let index = 0; index < that.multipleSelection.length; index++) {
                    if (!that.multipleSelection[index].IsRele) {
                        that.$util.warningMsg('更新商品中还有未关联的商品，请先关联');
                        return;
                    }
                    ids.push(this.multipleSelection[index].UGoodsId);
                }
                this.$util
                    .axiosPost({
                        url: `/api/EntpUnionGoods/BatchUpdateGoods`,
                        data: { uGoodsIds: ids, UnionId: that.searchData.UnionId }
                    })
                    .then(res => {
                        // this.$util.successMsg(res.errmsg);
                        let msg = `更新商品数${res.data.editCount}，跳过商品数${res.data.jumpCount}`;
                        that.$alert(msg, '保存成功', { confirmButtonText: '确定' });
                        this.getTableData();
                    })
                    .catch(() => { });
            }
        },
        async loopUpdateGoods() {
            const { data } = await this.$util
                .axiosPost({
                    url: '/api/EntpUnionGoods/LoopUpdateGoods',
                    data: this.searchApParams,
                    hideLoading: true
                })
                .catch(err => {
                    this.searchApParams._visible = false;
                    this.saveLoading = false;
                });

            this.searchApParams.editCount += data.editCount;
            this.searchApParams.jumpCount += data.jumpCount;
            if (this.searchApParams.page == 1) this.searchApParams._totalCount = data.count;
            this.searchApParams._percentage = parseInt(((this.searchApParams.page * this.searchApParams.limit) / this.searchApParams._totalCount) * 100);
            this.searchApParams._percentage = this.searchApParams._percentage > 100 ? 100 : this.searchApParams._percentage;
            let _stop = this.tableDataLength - this.searchApParams.page * this.searchApParams.limit < this.searchApParams._limit;
            this.searchApParams.page += 1;
            if (_stop) {
                this.searchApParams._percentage = 100;
                this.searchApParams._visible = false;
                this.saveLoading = false;
                let msg = `更新商品数${this.searchApParams.editCount}，跳过商品数${this.searchApParams.jumpCount}`;
                this.$alert(msg, '保存成功', { confirmButtonText: '确定' });
                this.getTableData();
            } else {
                this.loopUpdateGoods();
            }
        },
        getUnionReleResults() {
            let that = this;
            return new Promise(resolve => {
                that.$util
                    .axiosGet({
                        url: '/api/EntpUnions/GetUnionReleResults',
                        data: {
                            UnionId: that.searchData.UnionId
                        }
                    })
                    .then(res => {
                        let data = res.data;
                        if (data) {
                            if (!data.IsRele && !data.IsMine) {
                                that.releEntpId = data.ReleEntpId;
                                that.$confirm('您还没有对联盟拥有者进行实体关联，关联之前无法进行下单哟', '提示', {
                                    confirmButtonText: '提取实体',
                                    cancelButtonText: '关联实体',
                                    type: 'warning',
                                    center: false,
                                    distinguishCancelAndClose: true
                                })
                                    .then(() => {
                                        that.dialogFetchVisible = true;
                                    })
                                    .catch(action => {
                                        if (action === 'cancel') {
                                            that.dialogReleVisible = true;
                                        }
                                    });
                            } else resolve(data);
                        } else that.$util.warningMsg(res.errmsg);
                    });
            });
        },
        closeEntityDialog(isEdit) {
            this.dialogFetchVisible = false;
            if (isEdit) this.getUnionReleResults();
        },
        closeReleDialog(isEdit) {
            this.dialogReleVisible = false;
            if (isEdit) this.getUnionReleResults();
        },
        showCorrectAPMsgDialog(id) {
            if (id) {
                this.goodsId = id;
                this.recorrectAPMsgVisible = true;
            }
        },
        closeRecorrectAPMsgDialog() {
            this.recorrectAPMsgVisible = false;
        },
        closeViewer() {
            this.showViewer = false;
        },
        async getGoodsImages(goodsId) {
            this.srcList = [];
            const { data } = await this.$util.axiosGet({
                url: '/api/EntpGoods/GetGoodsImages',
                data: { goodsId: goodsId }
            });
            if (data) {
                this.srcList = data;
            }
            this.showViewer = true;
        }
    }
};
</script>
<style lang="less" scoped>
.saveProgress {
    position: absolute;
    top: 45%;
    left: 45%;
    z-index: 99999;
}
</style>
